import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  AuthFormWrapper,
  AuthPageWrapper,
  SelectSlug,
  UseFormLink,
} from '@web-apps/feature-auth'
import { Box } from '@web-apps/ui-shared'
import { getEnvironmentConfigs } from '../../../services/utility'
import { getIdentityAppUrl } from '../../../utils/helpers/url.helpers'


export const RegistrationPage = () => {
  const { t } = useTranslation(['auth'])
  const { search } = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(search)
  const slug = searchParams.get('slug')

  const handleSlugSelection = (selectedSlug: string) => {
    const newSearchParams = new URLSearchParams(searchParams)
    newSearchParams.set('slug', selectedSlug)
    navigate({ search: newSearchParams.toString() }, { replace: true })

    const params: Record<string, string> = {}
    newSearchParams.forEach((value, key) => {
      params[key] = value
    })

    window.location.href = getIdentityAppUrl('registration', params)
  }

  return (
    <div>
      <AuthPageWrapper
        homePage={getEnvironmentConfigs().homePage}
        partner={searchParams.get('partner')}
      >
        <AuthFormWrapper>
          <SelectSlug onSlugSubmit={handleSlugSelection} predefinedSlug={slug} />
        </AuthFormWrapper>
        <Box mt={16} mb={48}>
          <UseFormLink withBoldLink>
            {t('auth:register.already_have_account')}{' '}
            <a href={getIdentityAppUrl('login', Object.fromEntries(searchParams))}>
              {t('auth:login.log_in')}
            </a>
          </UseFormLink>
        </Box>
      </AuthPageWrapper>
    </div>
  )
}
